export interface GiftDialogFlowState<TGift, TPreview> {
  selectedGift: TGift | null;
  preview: TPreview | null;
  ruleDialogOpen: boolean;
}

export type GiftDialogFlowAction<TGift, TPreview> =
  | { type: 'reset' }
  | { type: 'open-single'; gift: TGift }
  | { type: 'close-single' }
  | { type: 'open-preview'; preview: TPreview }
  | { type: 'close-preview' }
  | { type: 'open-rule' }
  | { type: 'close-rule' };

export function createGiftDialogFlowInitialState<TGift, TPreview>(): GiftDialogFlowState<
  TGift,
  TPreview
> {
  return {
    selectedGift: null,
    preview: null,
    ruleDialogOpen: false,
  };
}

export function giftDialogFlowReducer<TGift, TPreview>(
  state: GiftDialogFlowState<TGift, TPreview>,
  action: GiftDialogFlowAction<TGift, TPreview>,
): GiftDialogFlowState<TGift, TPreview> {
  switch (action.type) {
    case 'reset':
      return createGiftDialogFlowInitialState<TGift, TPreview>();
    case 'open-single':
      return { ...state, selectedGift: action.gift };
    case 'close-single':
      return { ...state, selectedGift: null };
    case 'open-preview':
      return { ...state, preview: action.preview };
    case 'close-preview':
      return { ...state, preview: null };
    case 'open-rule':
      return { ...state, ruleDialogOpen: true };
    case 'close-rule':
      return { ...state, ruleDialogOpen: false };
  }
}

export function resolveGiftDialogLayerOpenState<TGift, TPreview>(
  parentOpen: boolean,
  state: GiftDialogFlowState<TGift, TPreview>,
) {
  return {
    details: parentOpen,
    single: parentOpen && state.selectedGift !== null,
    preview: parentOpen && state.preview !== null,
    rule: parentOpen && state.ruleDialogOpen,
  };
}
